import { HTMLAttributes, ReactNode } from 'react';
import { useTheme, type Theme } from '../../theme';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

function getCardStyle(theme: Theme): React.CSSProperties {
  return {
    width: theme.layout.cardWidth,
    minHeight: theme.layout.cardHeight,
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius.lg,
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.08)',
    padding: theme.spacing.xl,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  };
}

export default function Card({ children, style, ...rest }: CardProps) {
  const theme = useTheme();
  const cardStyle = getCardStyle(theme);
  return (
    <div
      className="e-learning-card"
      style={{ ...cardStyle, ...style }}
      {...rest}
    >
      {children}
    </div>
  );
}
